import React, { useState } from "react";
import useTitanApp from "../../../hooks/useTitanApp";
import { setShowMultipleVaccineCertificatePreview } from "../../../dispatchers/patientDispatchers";
import { patientPrescriptionDownloadPdfForVaccine } from "@/dispatchers/patientPrescriptionDispatcher";
import { Modal, Box, IconButton, Button } from "@mui/material";
import {
  getAuthHeader,
  refreshAuthToken,
} from "@/services/authToken";
import config from "@/config";
import { IoClose } from "react-icons/io5";
import { useSelector } from "react-redux";
import { generateVaccinePdfUrl } from "@/apiUrls/apiUrls";

export default function MultipleVaccinationPreviewModal() {
  const { appState, patientState } = useTitanApp();
  const { darkMode } = appState || {};
  const { showMultipleVaccineCertificatePreview, multipleVaccinationImage } =
    patientState || {};
  const [loading, setLoading] = useState(false);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: darkMode ? "#222" : "#fff",
    boxShadow: 24,
    borderRadius: "16px",
  };
  

  const vaccinePdfDownloadPayload = useSelector(
  (state: any) => state.patientPrescription.vaccinePdfDownloadPayload
);

  const handleCloseModal = () => {
    setShowMultipleVaccineCertificatePreview(false);
  };

  const handleDownload = () => {
    // 1. Create a hidden anchor tag
    const link = document.createElement("a");
    link.href = multipleVaccinationImage; // base‑64 data URI
    link.download = "vaccination-certificate"; // default filename (extension auto‑picked from MIME)
    // 2. Attach, click, and clean up
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


   const handleDownloadVaccinationCertificatePdf = async () => {
    if(vaccinePdfDownloadPayload === null ) return;
    try{
      setLoading(true);
      let authHeader = getAuthHeader();
            if (!authHeader) {
              await refreshAuthToken();
              authHeader = getAuthHeader();
      }
      const response = await fetch(
        `${config.localurl}${generateVaccinePdfUrl()}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: authHeader,
          },
          body: JSON.stringify(vaccinePdfDownloadPayload),
        },
      );

      if (!response.ok) {
        throw new Error("Failed to generate summary report PDF.");
      }

      const blob = await response.blob();
      const contentDisposition = response.headers.get("content-disposition");
      const fileNameMatch = contentDisposition?.match(
        /filename\*?=(?:UTF-8''|")?([^\";]+)/i,
      );
      const dateStr = new Intl.DateTimeFormat("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
        .format(new Date())
        .replace(/\//g, "-");
      
      const fileName = fileNameMatch?.[1]
        ? decodeURIComponent(fileNameMatch[1].replace(/"/g, ""))
        : `Vaccine_Report_${vaccinePdfDownloadPayload?.patientDetails?.name}_${dateStr}.pdf`;

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }
    catch(ex){
      console.log(ex);
    }
    finally{
      setLoading(false);
    }
  };

  return (
    <Modal open={showMultipleVaccineCertificatePreview}>
      <Box sx={style}>
        <div className="pc-actions-modal-wrapper prescription-preview vaccination-preview-image">
          <div className="pc-actions-modal-header">
            <h3></h3>
            <IoClose
              className="close-icon"
              onClick={handleCloseModal}
              color={darkMode ? "#f2f2f2" : "#222"}
              size={25}
            />
          </div>
          <div className="vc-actions-modal-content">
            <img
              src={multipleVaccinationImage}
              alt="Vaccination Preview"
              className="preview-image"
            />
          </div>
          <div className="download-button">
            <Button
              variant="contained"
              size="medium"
              disabled={loading}
              onClick={handleDownloadVaccinationCertificatePdf}
              className="ownload-btn px-5 py-2 text-base font-medium rounded-lg shadow-md hover:shadow-lg"
            >
              {loading ? "Downloading..." : "Download"} 
            </Button>
          </div>
        </div>
      </Box>
    </Modal>
  );
}
